import * as yup from "yup";

import { TSuggestionsResponse } from "../types";

const suggestionSchema = yup
  .object({
    items: yup
      .array(
        yup.object({
          title: yup.string().required(),
          id: yup.string().required(),
        })
      )
      .required(),
  })
  .required();
export const validateSuggestions = (responseData: any): TSuggestionsResponse =>
  suggestionSchema.validateSync(responseData);
